<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >
  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFileSample(file)"
    />
  </div>
  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
            :recognizeName="recognizeName"
          />
        </div>
      </div>
    </div>



    <div style="flex:0 0 15px;" />

    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile" :disable="checkPermission == false">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
        </q-btn-group>
        <q-space />
        <q-tabs
          v-model="state.tab"
          indicator-color="primary"
          inline-label
          shrink stretch
        >
          <q-tab name="config" icon="account_tree" label="Config" />
          <q-tab name="result" icon="account_tree" label="Result" />
        </q-tabs>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange" />
        </div>

        <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
          <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
            <q-tab-panel name="config">
              <json-viewer :value="configDataText" :expand-depth=4 copyable></json-viewer>
            </q-tab-panel>
            <q-tab-panel name="result">
              <json-viewer :value="jsonDataText" :expand-depth=10 copyable></json-viewer>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>


  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <span style="font-weight:bold;color:red">추후 설명 보충 필요(Sheldon)</span>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=169607185">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=169607185</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Sheldon
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import DocumentOCR from '@/js/document_ocr.js'
import ETC from '@/js/etc.js'
import UserJS from '@/js/user.js'

import _ from 'lodash'
import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }

    function preprocessingFileSample(data) {
      vm.proxy.sampleImageName = data.sampleImage.name
      return preprocessingImageFile(data.file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }

    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile,
      preprocessingFileSample
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        fitToWindow: false,
        searchText: null,
        tab: 'result',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2}
      },
      sampleImages: [
        {
          name: 'FamilyRelations',
          url: `${process.env.VUE_APP_URL}/api/image/261704C0-8C1E-41EA-84BC-9EF672FBA0F6.jpg`
        },
        {
          name: 'FamilyRelations',
          url: `${process.env.VUE_APP_URL}/api/image/26f9517a-dc8e-488c-a0fe-85d66c9c11da.jpg`
        },
        {
          name: 'Prescription1',
          url: `${process.env.VUE_APP_URL}/api/image/9F57A0DA-0832-424B-9CF7-7B45AB3123D0.jpg`
        },
        {
          name: 'Prescription2',
          url: `${process.env.VUE_APP_URL}/api/image/F9F63AB9-F776-43A4-834B-B1A8AAF60BB9.jpg`
        },        
        {
          name: 'BalanceSheet',
          url: `${process.env.VUE_APP_URL}/api/image/9F13117B-1B73-4753-B100-4B5EA7FBFA2B.jpg`
        },
        {
          name: 'BalanceSheet',
          url: `${process.env.VUE_APP_URL}/api/image/B1045E8B-0EE0-44DB-9333-8FA08D9E242B.jpg`
        },
        {
          name: 'hospital',
          url: `${process.env.VUE_APP_URL}/api/image/D7563AA7-4DDF-4614-BE84-AF4FC38D4CAF.jpg`
        },
        {
          name: 'hospital2',
          url: `${process.env.VUE_APP_URL}/api/image/CE8CAF16-5776-4501-9363-90F37ADC16CA.jpg`
        }
      ],
      fieldColors: [
        '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4', '#469990', '#dcbeff', '#9A6324', '#ffd8b1', '#aaffc3',
      ],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      fields: [],
      jsonData: [],
      configData: [],
      title: "범용 표문서 인식기",
      recognizeName: "gt",
    }
  },
  components: {
    ImageProcessingDialog,
    SampleImageList,
    ImageView,
    HealthCheckWidget
  },
  methods: {
    listen__x__onfilechange: function (file, options) {
      const Vue = this
      
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let processingTime
        try {
          const begin = new Date();
          var configName = 'config:' + Vue.sampleImageName
          if (configName == 'config:undefined')
            configName = 'config:FamilyRelations'
          ret = await DocumentOCR.recognizeGeneralTable(file, configName);
          processingTime = (new Date() - begin) / 1000
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        ret.data['processingTime'] = processingTime
        Vue.configData = ret.config
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__text_search__oninput: _.debounce(function (e) {
      this.state.searchText = e.target.value
    }, 300),
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
      this.fields = []
    },
    updateTagging() {
      for (let item of this.pred) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = this.state.bboxShow
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = false
          }
        }
      }

      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    healthCheckFunction: DocumentOCR.recognizeGeneralTable,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    searchTexts: function () {
      if (this.pred.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.pred.slice();
      } else {
        let searchTexts = [];
        for (let item of this.pred) {
          if (item.key.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    searchFields: function () {
      let searchFields = [];
      for (let item of this.fields) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1)
          searchFields.push(item);
      }
      return searchFields;
    },
    jsonDataText: function () {
      const jsonData = this.jsonData
      return jsonData
    },
    configDataText: function() {
      const configData = this.configData
      return configData
    },
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '권한이 없습니다.' 
    }
  },
  watch: {
    searchTexts: function () {
      this.updateTagging()
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>